/* eslint-disable */

import React from "react";
import Modal from "react-bootstrap/Modal";
import APIClient from "../client";
import {Tab, Tabs} from "react-bootstrap";
import Jobs from "./Jobs";

import cropr from "../../shared/utils/cropr";
import gettext from "../../shared/utils/gettext";
import {interpolate} from "../../shared/utils/legacy";
import LinkPartner from "./LinkedPartner";

class LinkDroneWerkers extends React.Component {
  state = {
    dWAuthorized: false,
  };

  async checkResources() {
    try {
      await APIClient.get(
        "/api/data/users/drone_resources/DW/",
        null,
        cropr.cloudfarm_oauth_token
      ).then((response) => {
        if (response.nr) {
          cropr.notify("success", response.nr + " nieuwe dronebeelden zullen worden gedownload");
        } else if (response.status) {
          cropr.notify(
            "danger",
            interpolate(
              "Momenteel is het niet mogelijk te controleren op nieuwe dronebeelden (%s)",
              [response.status]
            )
          );
        } else {
          cropr.notify("info", "Geen nieuwe dronebeelden beschikbaar");
        }
      });
    } catch {
      cropr.notify(
        "danger",
        "Momenteel is het niet mogelijk te controleren op nieuwe dronebeelden. Probeer het later nogmaals."
      );
    }
  }

  render() {
    return (
      <LinkPartner
        gid="dronewerkers" name="Dronewerkers" logo_url="/static/cloudfarm/img/dronewerkers.png" logo_height="30"
        setAuthorized={(authorized) => {
          this.setState({dWAuthorized: authorized})
        }}
        description={
          <p>
            Via het{" "}
            <a href="http://www.dronewerkers.nl/" target="_blank">
              Dronewerkers platform
            </a>{" "}
            kunt u eenvoudig dronevluchten bestellen. Ga naar de Dronewerkers om uw
            account te koppelen.
            <br/>
            <a href="https://portal.dronewerkers.nl/login" className="btn btn-primary">
              Naar Dronewerkers
            </a>
            {this.state.dWAuthorized
              ? <a href="#" onClick={() => this.checkResources()} className="btn btn-primary ml-1">
                Controleer op nieuwe dronebeelden
              </a> : null
            }
          </p>}
      >
        <Tab eventKey="tasks" title={gettext("Tasks")} disabled={!this.state.dWAuthorized}>
          {this.state.dWAuthorized ? (
            <Jobs online_service="DW" columns={["external_service_id", "date", "status"]}/>
          ) : null}
        </Tab>
      </LinkPartner>
    );
  }
}

export default LinkDroneWerkers;
